
const Loading = () => {
  return (
    <div></div>
  )
}

export default Loading